import type { BrokerSetting, BrokerType } from '@/services/api/brokers';

export const BROKER_TYPE_VALUES = ['TIED_AGENT', 'BROKER'] as const satisfies readonly BrokerType[];

export const BROKER_TYPE_LABELS: Record<BrokerType, string> = {
  TIED_AGENT: 'Tied Agent',
  BROKER: 'Broker',
};

export const BROKER_SETTING_VALUES = [
  'NO_FUTURES_MANUAL_REVIEW',
  'NO_AML_REQUIRED',
  'AML_RISK_LEVEL_ONLY',
  'MINIMAL_PERSONAL_IDENTITY_DATA',
  'FUTURES_APPROPRIATENESS_RESULT_ONLY',
] as const satisfies readonly BrokerSetting[];

export interface BrokerSettingOption {
  value: BrokerSetting;
  title: string;
  description: string;
}

export const BROKER_SETTING_OPTIONS: readonly BrokerSettingOption[] = [
  {
    value: 'NO_FUTURES_MANUAL_REVIEW',
    title: 'No Futures Manual Review',
    description: 'Clients of the broker will not have a manual review level for futures appropriateness. Any assessment that falls within the manual review level will be failed.',
  },
  {
    value: 'NO_AML_REQUIRED',
    title: 'No AML Required',
    description: "The broker will not have to submit AML assessments for their clients. Agreements must be in place that the Broker's own AML policies are sufficient.",
  },
  {
    value: 'AML_RISK_LEVEL_ONLY',
    title: 'AML Risk Level Only',
    description: 'The broker will only need to submit AML risk level only for their clients, without full AML assessment requirements.',
  },
  {
    value: 'MINIMAL_PERSONAL_IDENTITY_DATA',
    title: 'Minimal Personal Identity Data',
    description: 'The broker will only need to provide minimal personal identity data for their clients. This must be pre-approved with One Trading.',
  },
  {
    value: 'FUTURES_APPROPRIATENESS_RESULT_ONLY',
    title: 'Futures Appropriateness Result Only',
    description: 'The broker will only need to submit the futures appropriateness result for their clients, without submitting the answer itself.',
  },
];
